import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

// our components
import TrackingDrawer from './TrackingDrawer'
import NorowsData from './NorowsData'
import Notification from './Notification'
import Carrier from './Carrier'
import OrderStatus from './OrderStatus'
import Customer from './Customer'
import CarrierTracking from './CarrierTracking'
import Printer from './Printer'
import { getCarrierDisplayName } from './carrierMapper';

// mui components
import {
    Typography,
    FormControl,
    Pagination,
    Card,
    CardContent,
    Stack,
    Tooltip,
    IconButton,
    Button,
    Backdrop,
    CircularProgress,
    Drawer,
    Box,
    Divider,
    CardHeader,
    Paper,
    Grid,
    Select,
    MenuItem
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import Date from './Date'

import { fetchManifestDetail, resetManifestDetailNotifications } from '../../pages/ManifestDetail/manifestdetailSlice';
import { doGetMysqlDeliveries } from '../Reports/Deliveries/deliveriesmysqlSlice';
import { fetchCustomerDetails } from '../../pages/Reports/Deliveries/trackingEventsSlice';
import {
    fetchOrderDetail
} from '../../pages/OrderDetail/orderdetailsSlice';
import { fetchHubs } from './hubslice';
import OrderDrawer from '../../pages/General/OrderDrawer'
import WidthMaximize from './WidthMaximize'

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    boxShadow: 'unset',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    color: theme.palette.text.secondary,
    height: '100%'
}));

// Shared form element control focus styling matching production workspace rules
const enterpriseInputStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': { borderColor: '#CBD5E1' },
        '&.Mui-focused': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiSelect-select': {
        padding: '8px 14px !important',
        fontSize: '13px',
        color: '#1E293B',
        fontWeight: 500
    }
};

const ManifestDrawer = ({ visible, manifestId, manifestOnClose, manifestUrl }) => {
    const dispatch = useDispatch();
    const { manifestDetail, shipmentDetail } = useSelector(state => state.manifestdetails);
    const deliveries = useSelector(state => state.deliveriesmysql);
    const profile = useSelector(state => state.auth);
    const [meta, setMeta] = useState(deliveries.deliveriesData.meta);
    const hubs = useSelector(state => state.hubs);
    const orders = useSelector(state => state.ordersNew);
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [trackingMessage, setTrackingMessage] = useState(null);
    const [drawer, setDrawer] = useState(true);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isMultiPiece, setIsMultiPiece] = useState(false)
    const [drawerWidth, setDrawerWidth] = useState("80%");
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 5,
        page: 0,
      });
    const orderCallback = (item) => {
        dispatch(fetchOrderDetail(item));
        setOrderDrawerVisible(true)
    }
    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };
    const ondrawerclose = () => {
        dispatch(resetManifestDetailNotifications());
        setDrawer(false)
        manifestOnClose(false)
    }

    const columns = [
        {
            field: 'order_id',
            headerName: 'Order',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return <span style={{ color: 'rgb(24, 144, 255)', cursor: 'pointer' }} onClick={e => { orderCallback(params.row.order_id) }}>{params.row.order_id}</span>
    
            }
           
        },
        {
            field: 'tracking_number',
            headerName: 'Tracking Number',
            minWidth: 250,
            flex: 1,
            renderCell: (params) => {
                let tracking_number = (params.row.tracking_number
                    && typeof params.row.tracking_number !== "undefined" && params.row.tracking_number !== null)
                    ? params.row.tracking_number : "";
                let carrier_name = (params.row.label_carrier_name 
                    && typeof params.row.label_carrier_name !== "undefined" 
                    && params.row.label_carrier_name !== null)
                    ? getCarrierDisplayName(params.row.label_carrier_name, tracking_number)
                    : "";
                let message = (params.row && params.row.is_manifest_closed === false)
                    ? "This shipment manifest is not yet closed" : null;
                let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
                return (
                    <CarrierTracking trackingItems={tracking} dispatchCallback={trackingCallback} carrierImageWidth="60px" message={message} />
                )
            }
        },
        {
            field: 'shipment_status',
            headerName: 'Shipment Status',
            flex: 1,
            renderCell: (params) => {
                return (
                    <OrderStatus orderStatus={params.row.shipment_status}
                    />
                )
            }
        },
        {
            field: 'customer_first_name',
            headerName: 'Customer',
            flex: 1,
            renderCell: (params) => {
                let name = ""
                if (params.row.customer_first_name !== "undefined" && params.row.customer_first_name !== null) {
                    name = params.row.customer_first_name;
                }
                if (params.row.customer_last_name !== "undefined" && params.row.customer_last_name !== null && params.row.customer_last_name !== params.row.customer_first_name) {
                    name = name + " " + params.row.customer_last_name
                }
                return (
                    <Customer name={name} />
                )
            }
        },
        {
            field: 'actual_weight',
            headerName: 'Weight',
            width: 80,
            resizable: false,
            renderCell: (params) => {
                if (params.row && params.row.actual_weight) {
                    return params.row.actual_weight
                } else {
                    return "-"
                }
            }
        },
        // {
        //     field: 'shipment.v.created_at',
        //     headerName: 'Date',
        //     flex: 1,
        //     resizable: false,
        //     renderCell: (params) => {
        //         if (params.row && params.row.shipment && params.row.shipment.v && params.row.shipment.v.created_at) {
        //             return <Date date={params.row.shipment.v.created_at} />
        //         } else {
        //             return "-"
        //         }
        //     }
        // }
    ]

    const groupColumns = [
        {
            field: 'carrier_name',
            headerName: 'Carrier',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Carrier carrierName={params.row.carrier_name} width={"90px"} />
                )
            }
        },
        {
            field: 'hub',
            headerName: 'Hub',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.hub && hubs && typeof hubs.data[`params.row.hub`] !== "undefined" && typeof hubs.data[`params.row.hub`]["hub"] !== "undefined") {
                    return hubs.data[params.row.hub]["hub"]
                } else {
                    return params.row.hub
                }
            }
        },
        {
            field: 'total_shipments',
            headerName: 'Total Shipments',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.total_shipments) {
                    return params.row.total_shipments
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'manifest_number',
            headerName: 'Manifest Number',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return <> {(params.row.manifest_number != "") ? params.row.manifest_number : "-"} </>
            }
        },
        {
            field: 'manifest_url',
            headerName: 'Manifest PDF',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.manifest_url_modified && params.row.manifest_url_modified != "" && params.row.manifest_url_modified != null) {
                    return (
                        <>
                            <Tooltip title="View Manifest PDF" placement="left-start">
                                <IconButton sx={{ color: '#1976d2' }}>
                                    <RemoveRedEyeIcon onClick={() => window.open(params.row.manifest_url_modified)} style={{ cursor: 'pointer' }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Print Manifest PDF" placement="left-start">
                                <IconButton sx={{ color: '#1976d2' }}>
                                    <PrintIcon onClick={() => { setPrintUrl(params.row.manifest_url_modified); setIsPrinted(false) }} style={{ cursor: 'pointer' }} />
                                </IconButton>
                            </Tooltip>
                        </>)
                }else if (params.row.manifest_url && params.row.manifest_url != "" && params.row.manifest_url != null) {
                    return (
                        <>
                            <Tooltip title="View Manifest PDF" placement="left-start">
                                <IconButton sx={{ color: '#1976d2' }}>
                                    <RemoveRedEyeIcon onClick={() => window.open(params.row.manifest_url)} style={{ cursor: 'pointer' }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Print Manifest PDF" placement="left-start">
                                <IconButton sx={{ color: '#1976d2' }}>
                                    <PrintIcon onClick={() => { setPrintUrl(params.row.manifest_url); setIsPrinted(false) }} style={{ cursor: 'pointer' }} />
                                </IconButton>
                            </Tooltip>
                        </>)
                } else {
                    return "-"
                }
            }
        }
    ]

    useEffect(() => {
        if (manifestId !== '') {
            dispatch(fetchHubs())
            dispatch(fetchManifestDetail(manifestId))
        }
    }, [manifestId])

    useEffect(() => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: 10,
                start_date: "",
                end_date: "",
                order_id: "",
                order_status: [],
                receiver_province: "",
                receiver_country_code: "",
                tracking_number: "",
                carrier_name: [],
                platform_tags: [],
                customer_name: "",
                goods_out_note: "",
            }
        });
    }, [dispatch, manifestId])


    useEffect(() => {
        if (manifestId !== '') {
            dispatch(doGetMysqlDeliveries({
                ...meta,
                ...{
                    "shippingchimp_manifest_number": manifestId
                }
            }))
        }
    }, [manifestId, meta])

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    function CustomManifestDetailTitle() {
        return (
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                Carrier Manifest Detail
            </Typography>
        )
    }

    function CustomManifestDetailToolbar() {
        return (
            <GridToolbarContainer sx={{ p: 2, bgcolor: '#F8FAFC', borderBottom: '1px solid #E2E8F0' }}>
                <CustomManifestDetailTitle />
            </GridToolbarContainer>
        );
    }

    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows"
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography variant="body2" sx={{ fontSize: '12.5px', fontWeight: 600, color: '#475569' }}>
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>{deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data && deliveries.deliveriesData.data.length}</strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>{(deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.total) ? deliveries.deliveriesData.meta.total : 0}</strong>
                </Typography>
            </Box>
        )
    }


    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>Show</Typography>
                    <FormControl size="small" variant="outlined" sx={{ minWidth: 80, ...enterpriseInputStyles }}>
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>entries</Typography>
                </Stack>
            </Box>
        )
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    p: 2,
                    bgcolor: '#F8FAFC',
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                    width: '100%',
                    boxSizing: 'border-box'
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {
        return (
            <Box
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2',
                            color: '#FFFFFF',
                            '&:hover': { backgroundColor: '#115293' }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.current_page}
                    count={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.last_page}
                    onChange={onChangePagination}
                />
            </Box>
        );
    }

    const trackingCallback = (carriername, trackingNumber, message = null) => {
        setTrackingMessage(message)
        let apikey = (profile && profile.profile && profile.profile.api_token) ? profile.profile.api_token : "";
        const data = {'tracking_number': trackingNumber }
        dispatch(fetchCustomerDetails(data, apikey))
        setTrackingDrawerVisible(true)
    }
    const onClose = (values) => {
        setTrackingDrawerVisible(false);
    };

    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { 
                        width: drawerWidth,
                        backgroundColor: '#F8FAFC',
                        borderLeft: '1px solid #E2E8F0'
                    },
                }}
            >
                {(manifestDetail && manifestDetail.notification && manifestDetail.notification.show) &&
                    <Notification
                        is_open={manifestDetail.notification.show}
                        messageType={manifestDetail.notification.messageType}
                        messages={manifestDetail.notification.messageContent}
                        handleClose={() => dispatch(resetManifestDetailNotifications())}
                    />}
                {(shipmentDetail.notification && shipmentDetail.notification.show) &&
                    <Notification
                        is_open={shipmentDetail.notification.show}
                        messageType={shipmentDetail.notification.messageType}
                        messages={shipmentDetail.notification.messageContent}
                        handleClose={() => dispatch(resetManifestDetailNotifications())}
                    />}
                <Box sx={{ p: 3, width: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 3 }}>
                    
                    {/* Main Workspace Frame Card Header Component */}
                    <Card 
                        className="sc--cardhead--details"
                        sx={{ 
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }}
                    >
                        <CardHeader 
                            title={
                                <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                    Manifest Details
                                </Typography>
                            } 
                            action={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <WidthMaximize
                                        defaultWidth="80%"
                                        onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                    />
                                    <IconButton 
                                        aria-label="settings" 
                                        onClick={ondrawerclose}
                                        sx={{ 
                                            color: '#64748B',
                                            '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: '20px' }} />
                                    </IconButton>
                                </Stack>
                            } 
                            sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                    </Card>

                    {/* Section 1: Overview Analytical KPIs Matrix Widgets Grid */}
                    {manifestDetail && manifestDetail.loading === false &&
                        <Card 
                            sx={{ 
                                width: '100%',
                                backgroundColor: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: '16px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)'
                            }}
                        >
                            <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px', mb: 2.5 }}>
                                    Manifest Overview
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={6} sm={4} md={2.4}>
                                        <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700, color: '#64748B' }}>
                                            Manifest Number
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontSize: '14px', fontWeight: 700, color: '#1E293B', mt: 0.5, wordBreak: 'break-all' }}>
                                            {manifestId}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={2.4}>
                                        <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700, color: '#64748B' }}>
                                            Status
                                        </Typography>
                                        <Box sx={{ mt: 0.5 }}>
                                            <span style={{ display: 'inline-flex', padding: '2px 8px', fontSize: '11px', fontWeight: 700, borderRadius: '6px', backgroundColor: '#DCFCE7', color: '#15803D', textTransform: 'uppercase' }}>
                                                Closed
                                            </span>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={2.4}>
                                        <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700, color: '#64748B' }}>
                                            Carriers
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontSize: '16px', fontWeight: 800, color: '#1E293B', mt: 0.5 }}>
                                            {manifestDetail && manifestDetail.data && manifestDetail.data.carriersCount}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={2.4}>
                                        <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700, color: '#64748B' }}>
                                            Hubs
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontSize: '16px', fontWeight: 800, color: '#1E293B', mt: 0.5 }}>
                                            {manifestDetail && manifestDetail.data && manifestDetail.data.hubsCount}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={2.4}>
                                        <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700, color: '#64748B' }}>
                                            Shipments
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontSize: '16px', fontWeight: 800, color: '#1E293B', mt: 0.5 }}>
                                            {manifestDetail && manifestDetail.data && manifestDetail.data.shipmentsCount}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    }

                    {/* Section 2: Carrier Logistics Distribution Array Core Grid Matrix */}
                    {profile && profile.profile && (profile.profile.hide_carrier === false) &&
                        <Card 
                            className="sc--cardhead--details"
                            sx={{ 
                                width: '100%',
                                backgroundColor: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: '16px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                                overflow: 'hidden'
                            }}
                        >
                            <Box sx={{ width: '100%', background: '#fff' }}>
                                <CardHeader 
                                    title={
                                        <Typography variant="h6" component="h3" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                            Carrier Manifest Detail
                                        </Typography>
                                    } 
                                    action={
                                        <>
                                            {manifestDetail && manifestDetail.data && manifestDetail.data.groupedData && manifestDetail.data.groupedData.length != 0 && manifestUrl != "" &&
                                                <Button 
                                                    variant="outlined" 
                                                    onClick={() => window.open(process.env.REACT_APP_API_DOMAIN + '/utility/pdf/print?q=' + manifestUrl, "_blank")}
                                                    sx={{
                                                        textTransform: 'none',
                                                        borderRadius: '10px',
                                                        fontWeight: 700,
                                                        fontSize: '13px',
                                                        height: '36px',
                                                        borderColor: '#1976d2',
                                                        color: '#1976d2',
                                                        '&:hover': {
                                                            borderColor: '#115293',
                                                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    <LocalPrintshopOutlinedIcon sx={{ fontSize: '18px', mr: 1 }} />
                                                    Print All Manifests
                                                </Button>
                                            }
                                        </>
                                    }
                                    sx={{ p: 2.5, borderBottom: '1px solid #E2E8F0', backgroundColor: '#FFFFFF' }}
                                />
                                <DataGrid
                                    sx={{
                                        border: 'none',
                                        backgroundColor: '#FFFFFF',
                                        '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                        '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                                        '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                        '& .MuiDataGrid-row': { borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                        '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                        '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                    }}
                                    getRowId={(row) => row.id}
                                    rows={manifestDetail && manifestDetail.data && manifestDetail.data.groupedData}
                                    columns={groupColumns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    pageSizeOptions={[5, 10, 25]}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    disableRowSelectionOnClick
                                    slots={{
                                        NorowsData,
                                        loadingOverlay: LinearProgress,
                                        toolbar: CustomManifestDetailToolbar
                                    }}
                                    loading={
                                        (manifestDetail && manifestDetail.loading) ||
                                        (orders && orders.bulkLabel && orders.bulkLabel.loading)
                                    }
                                />
                            </Box>
                        </Card>
                    }

                    {/* Section 3: Shipment Trajectory Tracking Records Main Workspace Grid Matrix */}
                    <Card 
                        className="sc--cardhead--details"
                        sx={{ 
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }}
                    >
                        <Box sx={{ width: '100%', background: '#fff' }}>
                            <CardHeader 
                                title={
                                    <Typography variant="h6" component="h3" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                        Shipment Details
                                    </Typography>
                                } 
                                action={
                                    <a 
                                        href={process.env.REACT_APP_API_DOMAIN + `/labelgen/shipment/manifest-export?shippingchimp_manifest_number=${manifestId}`}
                                        style={{ textDecoration: 'none' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                    >
                                        <Button 
                                            variant="outlined"
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: '10px',
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                height: '36px',
                                                borderColor: '#E2E8F0',
                                                color: '#475569',
                                                '&:hover': {
                                                    borderColor: '#CBD5E1',
                                                    backgroundColor: '#F8FAFC',
                                                    color: '#1E293B'
                                                }
                                            }}
                                        >
                                            <FileDownloadOutlinedIcon sx={{ fontSize: '18px', mr: 1 }} /> 
                                            Export
                                        </Button>
                                    </a>
                                }
                                sx={{ p: 2.5, borderBottom: '1px solid #E2E8F0', backgroundColor: '#FFFFFF' }}
                            />
                            <DataGrid
                                sx={{
                                    border: 'none',
                                    backgroundColor: '#FFFFFF',
                                    overflow: 'hidden',
                                    '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                                    '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                    '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' }, '&.Mui-selected': { backgroundColor: 'rgba(25, 118, 210, 0.04)', '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' } } },
                                    '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                    '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                }}
                                getRowId={(row) => row.tracking_number}
                                rows={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data}
                                columns={columns}
                                autoHeight={true}
                                disableColumnFilter={true}
                                disableColumnMenu={true}
                                sortingMode="server"
                                onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                                sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                                disableRowSelectionOnClick
                                slots={{
                                    loadingOverlay: LinearProgress,
                                    footer: CustomPagination,
                                    toolbar: CustomToolbar,
                                    NorowsData
                                }}
                                loading={
                                    (deliveries && deliveries.deliveriesData.loading)
                                }
                            />
                        </Box>
                    </Card>
                    
                    <TrackingDrawer
                        visible={trackingDrawerVisible} message={trackingMessage} isMultiPiece={isMultiPiece} onClose={onClose}
                    />
                    <OrderDrawer
                        visible={orderDrawerVisible} onClose={orderOnClose}
                    />
                </Box>
            </Drawer>
        </>
    )
}

export default ManifestDrawer;